export default "<div fxFlex=\"100\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"